import { DESCRIPTION, INCIDENT_CATEGORY } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { routes } from "@/routes/utils";
import { schema } from "./validations";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Incident Category",
    moduleRoute: `${routes.masterData}/${routes.incidentCategory}`,
    schema,
    defaultValues: { [INCIDENT_CATEGORY]: "", [DESCRIPTION]: "" },
    nameFieldKey: INCIDENT_CATEGORY,
    queryKeyToInvalidate: "incident-categories",
    module: "incident-categories",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Category Name"
    />
  );
};

export default AddEdit;
